import Vue from 'vue'

import {
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  Form,
  Field,
  Toast,
  Cell,
  List,
  Icon,
  Grid,
  GridItem,
  CellGroup 
} from 'vant'

Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Cell)
Vue.use(List)
Vue.use(Icon)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(CellGroup)
